<template>
    <div>
      <div elevation="0" color="transparent" flat>
        <div class="row mb-8">
          <div class="col-6 d-flex justify-content-start">
            <v-card-title>
              {{ $t('masterOrders.docTitle') }}
            </v-card-title>
          </div>
          
         
        </div>
      </div>

   
      <v-card elevation="0">
        <MasterOrdersList />
      </v-card>
    </div>
  </template>
  
  <script>
  import MasterOrdersList from "./MasterOrdersList/MasterOrdersList.vue";

  
  export default {
    components: {
        MasterOrdersList,
    },
    mounted() {
      document.title = window.VUE_APP_NAME + ' - ' + this.$t('masterOrders.docTitle');
    },
  };
  </script>
  
  <style scoped>
  .v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
  }
  </style>